var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React, { memo, useMemo } from 'react';
import styled from 'styled-components';
import { Box, Text } from 'pcln-design-system';
import dayNameBuilder from '../utils/dayNameBuilder/dayNameBuilder';
var DayName = styled(Box)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  &&& {\n    display: inline-block;\n    vertical-align: top;\n    text-transform: capitalize;\n    padding: 2px 0;\n    text-align: center;\n  }\n"], ["\n  &&& {\n    display: inline-block;\n    vertical-align: top;\n    text-transform: capitalize;\n    padding: 2px 0;\n    text-align: center;\n  }\n"])));
function DayNames(_a) {
    var locale = _a.locale;
    var memoizedDays = useMemo(function () { return dayNameBuilder({ format: 'abbreviated', locale: locale }); }, [locale]);
    return (React.createElement(Box, { pt: '10px' }, memoizedDays.map(function (name, index) { return (React.createElement(DayName, { key: name, width: 1 / 7, "data-testid": "day-name-".concat(index) },
        React.createElement(Text, { fontSize: 0, color: 'text.light' }, name))); })));
}
export default memo(DayNames);
var templateObject_1;
//# sourceMappingURL=DayNames.js.map